const counters = [
  {
    category: "category",
  },
  {
    heading_1: "counter",
    heading_2: "counter",
    counter_1_1: "つ〜",
    counter_hiragana_1_1: "つ",
    list_1_1: "counted with the wago-system",
    title_1_1: "everything but living things",
    counter_2_1: "枚",
    counter_hiragana_2_1: "まい",
    title_2_1: "thin, flat objects",
    list_2_1: "clothes, sheets of paper, photographs, etc",
    counter_2_2: "月",
    counter_hiragana_2_2: "つき/がつ",
    list_2_2: "がつ for each month's name, つき counts the number of months",
    title_2_2: "months",
    counter_2_3: "人",
    counter_hiragana_2_3: "り/にん",
    list_2_3: "people, humanoids, angels, mermaids, etc",
    title_2_3: "humans, human-like creatures",
    counter_2_4: "階",
    counter_hiragana_2_4: "かい",
    list_2_4: "you can add 建て (だて) to say the building has n floors",
    title_2_4: "floors in a building",
    //common
    counter_3_1: "箇所",
    counter_hiragana_3_1: "かしょ",
    list_3_1:
      "places, mosquito bites, changed parts, toilets, malls, spots, points, and more",
    title_3_1: "counts any kind of place",
    counter_3_2: "箇月",
    counter_hiragana_3_2: "かげつ",
    list_3_2:
      "a more common way of counting months, especially when counting three or more",
    title_3_2: "number of months",
    counter_3_3: "箇国",
    counter_hiragana_3_3: "かこく",
    list_3_3: "you can use 国 (こく) when counting countries in general",
    title_3_3: "individual countries",
    counter_3_4: "口",
    counter_hiragana_3_4: "くち",
    list_3_4: "sips, bites, swords, price-winning submissions, and more",
    title_3_4: "bites of something, and more",
    counter_3_5: "缶",
    counter_hiragana_3_5: "かん",
    list_3_5: "soda cans, tuna cans, spray cans, etc",
    title_3_5: "all kinds of cans",
    counter_3_6: "足",
    counter_hiragana_3_6: "そく",
    list_3_6:
      "shoes, socks, flip flops, boots, sheets of dried squid, ice skates, etc",
    title_3_6: "footwear and some other things",
    counter_3_7: "曲",
    counter_hiragana_3_7: "きょく",
    list_3_7:
      "the kanji itself means song, and can be used as a counter for just that",
    title_3_7: "songs and music",
    counter_3_8: "切れ",
    counter_hiragana_3_8: "きれ",
    list_3_8: "slices of any kind of food",
    title_3_8: "sliced things",
    counter_3_9: "円",
    counter_hiragana_3_9: "えん",
    list_3_9: "counts an amount of yen",
    title_3_9: "yen",
    //less common
    counter_4_1: "駅",
    counter_hiragana_4_1: "えき",
    list_4_1: "bus stations, train stations (〜つ is also common here)",
    title_4_1: "stations",
    counter_4_2: "位",
    counter_hiragana_4_2: "い",
    list_4_2: "decimal places, souls, ghosts, ranks, classes, etc",
    title_4_2: "classes, grades, rankes and so on",
    counter_4_3: "院",
    counter_hiragana_4_3: "いん",
    list_4_3: "hospitals, clinics, temples, government houses, and so on",
    title_4_3: "organizations etc that ends with 院",
    counter_4_4: "籠",
    counter_hiragana_4_4: "かご",
    list_4_4: "baskets, bird cages, baskets containing something, and so on",
    title_4_4: "baskets",
  },
  {
    heading_1: "counter",
    heading_2: "counter",
    counter_1_1: "個",
    counter_hiragana_1_1: "こ",
    title_1_1: "anything with a distinct shape",
    list_1_1: "usually used for small and/or round objects",
    counter_2_1: "年",
    counter_hiragana_2_1: "ねん",
    list_2_1: "counting 四年 will change the pronunciation of よん (四) to よ",
    title_2_1: "years, grades",
    counter_2_2: "羽",
    counter_hiragana_2_2: "わ",
    list_2_2: "chickens, origami cranes, peacocks, penguins, etc",
    title_2_2: "birds",
    counter_2_3: "台",
    counter_hiragana_2_3: "だい",
    list_2_3: "furniture, whole cakes, cars, machines, and much more",
    title_2_3: "a wide variety of categories",
    counter_2_4: "時間",
    list_2_4: "can also be used to count numbers of classes in school",
    counter_hiragana_2_4: "じかん",
    title_2_4: "hours",
    //common
    counter_3_1: "皿",
    counter_hiragana_3_1: "さら",
    list_3_1: "dishes, one serving of (cold) soba, plates, etc",
    title_3_1: "plates and food on plates",
    counter_3_2: "件",
    counter_hiragana_3_2: "けん",
    list_3_2: "plans, loans, emails, scandals, projects, suggestions, and more",
    title_3_2: "cases and matters",
    counter_3_3: "軒",
    counter_hiragana_3_3: "けん",
    list_3_3:
      "shops, restaurants, farms, factories, apartments, households, etc",
    title_3_3: "houses and buildings",
    counter_3_4: "試合",
    counter_hiragana_3_4: "しあい",
    list_3_4: "ゲーム (gēmu) is also used",
    title_3_4: "(sports) games, matches",
    counter_3_5: "校",
    counter_hiragana_3_5: "こう",
    list_3_5:
      "schools, elementary schools, pre-schools, secondary schools, and so on",
    title_3_5: "schools",
    counter_3_6: "品",
    counter_hiragana_3_6: "しな/ひん",
    list_3_6: "when using しな, the wago-system is used for 1 and 2",
    title_3_6: "items, dishes of food, products",
    counter_3_7: "語",
    counter_hiragana_3_7: "ご",
    list_3_7: "ワード (wōdo) is also used, but 語 is more common",
    title_3_7: "words",
    counter_3_8: "組",
    counter_hiragana_3_8: "くみ",
    list_3_8: "a couple or pair of any kind; gloves, sacked food, cards, etc",
    title_3_8: "pairs, sets",
    counter_3_9: "社",
    counter_hiragana_3_9: "しゃ",
    list_3_9: "companies, publishers, shrines, etc",
    title_3_9: "companies or temples",
    //less common
    counter_4_1: "枝",
    counter_hiragana_4_1: "えだ",
    list_4_1: "branches with leaves, flowers and leaves",
    title_4_1: "branches",
    counter_4_2: "園",
    counter_hiragana_4_2: "えん",
    list_4_2: "theme parks, zoos, kindergartens, preschools, etc",
    title_4_2: "institutions ending with 園/園地 (ち)",
    counter_4_3: "音",
    counter_hiragana_4_3: "おん",
    list_4_3: "musical scales, musical notes, syllables",
    title_4_3: "sounds, syllables, musical notes",
    counter_4_4: "階級",
    counter_hiragana_4_4: "かいきゅう",
    list_4_4: "ranks, grades, or classes",
    title_4_4: "ranks/grades",
  },
  {
    heading_2: "counter",
    counter_2_1: "頭",
    counter_hiragana_2_1: "とう",
    list_2_1:
      "cows, horses, whales, tigers, etc. Also animals for sale, insects on display and more",
    title_2_1: "big animals",
    counter_2_2: "日",
    counter_hiragana_2_2: "か/にち",
    list_2_2:
      "1-10 is counted with the wago-system (with a twist) and has the か-ending",
    title_2_2: "days",
    counter_2_3: "匹",
    counter_hiragana_2_3: "ひき",
    list_2_3: "fish, monkeys, naughty children, ogres, snails, etc",
    title_2_3: "insects, small animals and more",
    //common
    counter_3_1: "種類",
    counter_hiragana_3_1: "しゅるい",
    list_3_1: "kinds, varieties and types of things",
    title_3_1: "kinds, varieties and types of things",
    counter_3_2: "週",
    counter_hiragana_3_2: "しゅう",
    list_3_2: 'to count "for n weeks", the 間 (かん) suffix can be added',
    title_3_2: "weeks",
    counter_3_3: "周",
    counter_hiragana_3_3: "しゅう",
    list_3_3: "circuits, laps, traveling around something, courses",
    title_3_3: "rounds",
    counter_3_4: "席",
    counter_hiragana_3_4: "せき",
    list_3_4: "read with the kango reading",
    title_3_4: "seats, performances, contest rankings, etc",
    counter_3_5: "色",
    counter_hiragana_3_5: "しょく/いろ",
    list_3_5: "read with the kango reading",
    title_3_5: "colors",
    counter_3_6: "戦",
    counter_hiragana_3_6: "せん",
    list_3_6:
      "chess matches, board game matches, games, sports games, fights, and so on",
    title_3_6: "fights, matches, sports game matches, etc",
    counter_3_7: "巻",
    counter_hiragana_3_7: "かん",
    list_3_7: "volumes of books, videotapes, CDs, and so on",
    title_3_7: "things in a series",
    counter_3_8: "束",
    counter_hiragana_3_8: "たば",
    list_3_8: "bundles of firewood, noodles, papers, bouquets, etc",
    title_3_8: "bundles",
    counter_3_9: "玉",
    counter_hiragana_3_9: "たま",
    list_3_9:
      "round fruit/vegetables, balls of noodles, balls of yarn, and so on",
    title_3_9: "ball-shaped things",
    //less common
    counter_4_1: "海",
    counter_hiragana_4_1: "かい",
    list_4_1: "the meaning of this kanji is sea, and it counts just that",
    title_4_1: "seas, oceans",
    counter_4_2: "課",
    counter_hiragana_4_2: "か",
    list_4_2:
      "lessons, compaty/organization sections, divisions, office teams, etc",
    title_4_2: "lessons/sections of a company",
    counter_4_3: "折/折り",
    counter_hiragana_4_3: "おり",
    list_4_3:
      "paper cranes, boxes of cakes, boxes of sweets, and so on (first and second fold is counted with wago)",
    title_4_3: "folded boxes, folded paper",
    counter_4_4: "方",
    counter_hiragana_4_4: "かた",
    list_4_4: "formal way of counting people, e.g. in an office setting",
    title_4_4: "people",
  },
  {
    heading_2: "counter",
    counter_2_1: "歳",
    counter_hiragana_2_1: "さい",
    list_2_1:
      "when counting children's ages up to ten, the 〜つ counter can also be used",
    title_2_1: "age (years)",
    counter_2_2: "冊",
    counter_hiragana_2_2: "さつ",
    list_2_2: "magazines, books, dictionaries, etc",
    title_2_2: "books",
    counter_2_3: "回",
    counter_hiragana_2_3: "かい",
    list_2_3:
      "also counts the number of times something happens and regular events/series of events",
    title_2_3: "chances, opportunities and more",
    //common
    counter_3_1: "着",
    counter_hiragana_3_1: "ちゃく",
    list_3_1: "robes, costumes, coats, suits, swimsuts, and so on",
    title_3_1: "clothes, race placement suffix",
    counter_3_2: "段",
    counter_hiragana_3_2: "だん",
    list_3_2:
      "paragraphs, steps of stairs, bunk bed levels, cake tiers, columns, drawers",
    title_3_2: "levels/layers",
    counter_3_3: "粒",
    counter_hiragana_3_3: "つぶ",
    list_3_3:
      "drops of water, pills, caviar, pebbles, almonds, peas, grains of sand, etc",
    title_3_3: "very small things",
    counter_3_4: "通",
    counter_hiragana_3_4: "つう",
    list_3_4:
      "postcards, letters, mail, bills, invoices, passports, driver's licenses, and so on",
    title_3_4: "messages/official documents",
    counter_3_5: "点",
    counter_hiragana_3_5: "てん",
    list_3_5:
      "dots, drawings, novels, stuffed animals, test scores, accessories, etc",
    title_3_5: "points/dots, artwork",
    counter_3_6: "度",
    counter_hiragana_3_6: "ど/たび",
    list_3_6: "opportunities, series of actions, degrees, temperature, etc",
    title_3_6: "number of times and much more",
    counter_3_7: "歩",
    counter_hiragana_3_7: "ほ",
    list_3_7:
      "steps taken while walking, progress in your work, steps in your education, and so on",
    title_3_7: "steps taken",
    counter_3_8: "泊",
    counter_hiragana_3_8: "はく",
    list_3_8: "overnight rentals, overnight stays",
    title_3_8: "overnight stays",
    counter_3_9: "箱",
    counter_hiragana_3_9: "はこ",
    list_3_9: "lunchboxes, boxes, cardboard boxes, and so on",
    title_3_9: "boxes",
    counter_3_10: "発",
    counter_hiragana_3_10: "はつ",
    list_3_10:
      "farts, punches, jokes, kicks, missiles, sex, baseball hits, and so on",
    title_3_10: "explosives, fireworks, bullets, etc",
    //less common
    counter_4_1: "画",
    counter_hiragana_4_1: "かく",
    list_4_1: "kanji strokes, plots/division/blocks of land, etc",
    title_4_1: "kanji strokes",
    counter_4_2: "片",
    counter_hiragana_4_2: "かけ",
    list_4_2: "garlic gloves, apple pieces, pieces of bread, and so on",
    title_4_2: "randomly broken pieces",
    counter_4_3: "案",
    counter_hiragana_4_3: "あん",
    list_4_3: "can also be counted with 〜つ, although 案 is more common",
    title_4_3: "plans, ideas, projects, strategies",
    counter_4_4: "塊",
    counter_hiragana_4_4: "かたまり",
    list_4_4: "balls, chunks, lumps, clouds, dirt, fish, people, etc",
    title_4_4: "lumps, masses",
  },
  {
    heading_2: "counter",
    counter_2_1: "分",
    counter_hiragana_2_1: "ふん",
    list_2_1: "also counts latitude and longitude",
    title_2_1: "minutes, time, degree",
    counter_2_2: "時",
    counter_hiragana_2_2: "じ",
    list_2_2: "a.m.: 午前 (ごぜん), p.m.: 午後 (ごご)",
    title_2_2: "o'clock",
    counter_2_3: "本",
    counter_hiragana_2_3: "ほん",
    list_2_3: "pens, film, bottles, batteries, eels, nail clippers, etc",
    title_2_3: "long, cylindrical objects",
    //common
    counter_3_1: "番",
    counter_hiragana_3_1: "ばん",
    list_3_1:
      "turns, ranks, numbers, chess and sumo matches, verses of a song, etc",
    title_3_1: "one's order, turn or rank",
    counter_3_2: "秒",
    counter_hiragana_3_2: "びょう",
    list_3_2: "angles, latitude, longitude, seconds",
    title_3_2: "unit used for seconds",
    counter_3_3: "袋",
    counter_hiragana_3_3: "ふくろ",
    list_3_3: "bags, sacks, pouches, shopping/paper/garbage bags etc",
    title_3_3: "bags, sacks etc",
    counter_3_4: "便",
    counter_hiragana_3_4: "びん",
    list_3_4:
      "flights, flight numbers, bus numbers, long-distance bus trips, deliveries",
    title_3_4: "e.g. boats shipping out over a period of time",
    counter_3_5: "部屋",
    counter_hiragana_3_5: "へや",
    list_3_5:
      "closets, storage rooms, hotel rooms, back rooms, bedrooms, living rooms, and so on",
    title_3_5: "rooms",
    counter_3_6: "杯",
    counter_hiragana_3_6: "はい",
    list_3_6:
      "mugs/cups/glasses of any drink, crabs, octopuses, ships, bowls of rice, etc",
    title_3_6: "liquids in cups/bowls and other things",
    counter_3_7: "名",
    counter_hiragana_3_7: "めい",
    list_3_7: "a more polite version of counting a number of people",
    title_3_7: "number of people",
    counter_3_8: "文字",
    counter_hiragana_3_8: "もじ",
    list_3_8: "letters, characters, morae in poetry",
    title_3_8: "letters/characters",
    counter_3_9: "問",
    counter_hiragana_3_9: "もん",
    list_3_9: "questions/problems in a quiz/test/exam/worksheet, and so on",
    title_3_9: "questions in a test etc",
    //less common
    counter_4_1: "河川",
    counter_hiragana_4_1: "かせん",
    list_4_1:
      "formal way of counting rivers. 本 is a more common counter for this",
    title_4_1: "rivers",
    counter_4_2: "株",
    counter_hiragana_4_2: "かぶ",
    list_4_2:
      "clusters of mushroom, tree stumps, seedlings, plants with roots, and so on",
    title_4_2: "plants with roots, tree stumps, etc",
    counter_4_3: "回線",
    counter_hiragana_4_3: "かいせん",
    list_4_3:
      "electrical circuits, optical communication lines, internet connections, and so on",
    title_4_3: "phone/internet lines/connections",
    counter_4_4: "画素",
    counter_hiragana_4_4: "がそ",
    list_4_4:
      "this is the unit for pixels. ピクセル (pikuseru) can also be used",
    title_4_4: "pixels",
  },
];
export default counters;
